import type {
    UpdateAmeriaPaymentInput,
    UpdateFlittPaymentInput,
} from '@travelity/api/services';
import type { GetUserResAccountSettingsFinancialPaymentGatewaysItemDto } from '@travelity/api/generated';

import type { PaymentGatewayFormValues } from './types';

export const buildDefaultValues = (
    paymentGateway?: GetUserResAccountSettingsFinancialPaymentGatewaysItemDto
) => {
    if (!paymentGateway)
        return {
            enabled: false,
            merchant_id: '',
            secret_key: '',
            client_id: '',
            username: '',
            password: '',
        };

    const { provider } = paymentGateway.reference;

    if (provider === 'ameriabank') {
        return {
            enabled: true,
            client_id: paymentGateway.reference.client_id,
            username: paymentGateway.reference.username,
            password: 'password',
        };
    }

    return {
        enabled: true,
        merchant_id: paymentGateway.reference.merchant_id,
        secret_key: 'secretKey',
    };
};

export const buildPayload = (
    values: PaymentGatewayFormValues,
    provider: 'flitt' | 'ameriabank'
): UpdateAmeriaPaymentInput | UpdateFlittPaymentInput | null => {
    if (provider === 'flitt' && 'merchant_id' in values) {
        return {
            provider: 'flitt',
            merchant_id: values.merchant_id,
            secret_key: values.secret_key,
        };
    }
    if (provider === 'ameriabank' && 'client_id' in values) {
        return {
            provider: 'ameriabank',
            client_id: values.client_id,
            username: values.username,
            password: values.password,
        };
    }

    return null;
};
